<div class="btn-open-table">
  <button (click)="onOpenTableClick()" class="btn-{{ animation }}">
    <mat-icon class="icon-btn-open-table" aria-hidden="true">{{
      btnIcon
    }}</mat-icon>
    {{ textButton }}
  </button>
</div>

<div class="table-{{ animation }}">
  <div class="responsive-table">
    <table class="table">
      <thead>
        <tr>
          <th scope="col" class="features"></th>
          <th
            scope="col"
            class="planName"
            *ngFor="let product of shopWindowItems"
          >
            {{ product.cardTitle }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let featureName of featureNames; let i = index">
          <th scope="row" class="featureItem">
            <div class="featureItem-content">
              <span class="name">{{ featureName }}</span>
              <div *ngIf="featureItems[featureName].tooltip">
                <span (mouseenter)="featureItems[featureName].showTooltip = true"
                  (mouseleave)="featureItems[featureName].showTooltip = false">
                  <mat-icon
                    class="mat-icon-report material-icons-outlined material-icons mat-icon-no-color ng-star-inserted"
                    aria-hidden="true"
                    >report</mat-icon
                  >
                  <div
                    class="custom-tooltip"
                    [ngClass]="{ 'tooltip-visible': featureItems[featureName].showTooltip }"
                  >
                    {{featureItems[featureName].tooltip}}
                    <span class="tooltip-arrow"></span>
                  </div>
                </span>
              </div>
            </div>
          </th>
          <td class="comparative" *ngFor="let product of shopWindowItems">
            <mat-icon
              class="mat-icon notranslate {{
                getIcon(product.featureList[i])
              }} material-icons mat-icon-no-color ng-star-inserted"
              aria-hidden="true"
              >{{ getIcon(product.featureList[i]) }}</mat-icon
            >
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th scope="row" class="th-btns"></th>
          <td *ngFor="let product of shopWindowItems; let i = index">
            <button (click)="onClick(i)" class="btn-subscribe">ASSINAR</button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
